import { render, staticRenderFns } from "./heartRate.vue?vue&type=template&id=0049c540&scoped=true&"
import script from "./heartRate.vue?vue&type=script&lang=js&"
export * from "./heartRate.vue?vue&type=script&lang=js&"
import style0 from "./heartRate.vue?vue&type=style&index=0&id=0049c540&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0049c540",
  null
  
)

export default component.exports